export default "__VITE_ASSET__DlZKlchi__"